



















import { Vue, Component, Mixins } from "vue-property-decorator";

import _ from "lodash";

import MyCommon from "@/mixins/common";

import SelectStadium from "@/components/selectstadium.vue";

import VChart, { THEME_KEY } from "vue-echarts";

@Component({
  components: {
    SelectStadium,
    VChart
  },
  provide: {
    [THEME_KEY]: "light"
  }
})
export default class extends Mixins(MyCommon) {
  stadiumId: string = "";
  startTime: string = "";
  endTime: string = "";

  option: any = {
    // title: {
    //   text: '用户订单增长曲线',
    //   subtext: ''
    // },
    grid: {
      // width: '100%',
      // left: '3%',
      // right: '4%',
      // bottom: '3%',
      containLabel: true
    },
    legend: {
      data: ["订单数"]
    },
    tooltip: {
      trigger: "axis"
    },
    xAxis: {
      type: "category",
      data: []
    },
    yAxis: {
      type: "value"
    },
    series: [
      {
        data: [],
        type: "line",
        name: "订单数",
        markLine: {
          data: [{ type: "average", name: "平均值" }]
        }
      }
    ]
  };

  ei: any = {};

  async loadData() {
    const res1 = await this.$store.dispatch("statistics/getOrders", {
      stadium_id: this.stadiumId,
      start_time: this.startTime,
      end_time: this.endTime
    });
    if (res1 && res1.Data) {
      this.option.xAxis.data = [];
      this.option.xAxis.data = res1.Data.categories;
      this.option.series[0].data = [];
      // let data1: number[] = []
      for (const k in res1.Data.data) {
        if (!_.isUndefined(res1.Data.data[k])) {
          this.option.series[0].data.push(res1.Data.data[k]);
        }
      }

      // this.option.series[0].data = res1.Data.data
      // console.log(this.option)
    }
  }

  mounted() {
    this.loadData();
  }

  stadiumcallback(val: any) {
    this.stadiumId = val;
    this.loadData();
  }

  changeDate(dates: any[], dateStrings: any[]) {
    this.startTime = `${dateStrings[0]} 00:00:00`;
    this.endTime = `${dateStrings[1]} 23:59:59`;
    this.loadData();
  }
}
